import React from 'react'
import styled from 'styled-components'

const Paper = styled.div`
  box-sizing: border-box;
`

const Option = styled.a`
  box-sizing: border-box;
`

Option.Group = styled.div`
  box-sizing: border-box; padding: 1rem;
  display: flex; justify-content: flex-end;
`

const Box = styled.div`
  min-width: 32.5%; max-width: 32.5%; margin: 0.5rem 0;
`

Box.Group = styled.div`
  flex: 1 1 auto; box-sizing: border-box;
  display: flex; flex-wrap: wrap; justify-content: space-between;
`

const DetailChartsWidget = () => {
  const [options, setOption] = React.useState({ showDetails: false })

  const markets = [
    { symbol: 'CRYPTOCAP:BTC.D', title: '🍕 비트코인 도미넌스', desc: '24시간 체크되며, 비트코인의 시장지배력을 의미하며, 🔴상승시 알트의 전반적인 자금이 유출되고 있음을 암시합니다. 🟢하락시 알트 상승, 총시총의 약진을 의미합니다. 과한 비트의 도미넌스 상승시기가 매수타점 시기입니다.' },
    { symbol: 'CRYPTOCAP:OTHERS.D', title: '🌱 알트 도미넌스', desc: '24시간 체크되며, 비트코인의 시장지배력을 의미하며, 🟢상승시 알트의 전반적인 자금이 진입되고 있음을 암시합니다. 🔴하락시 알트 자금유출 총시총 하락을 의미합니다. 과한 알트의 도미넌스 하락시기가 매수타점 시기입니다.' },
    { symbol: 'TSX:BITI', title: '🧛‍♂️ 조심하자, BITI 펀드..."비트의 하방에 배팅하는 빌런"', desc: '우리나라 시간 23시 30분 개장, 오전 6시 30분 폐장 주말, 공휴일 쉼, 캐나다토론토증권거래소의 한국 미래에셋 운영사의 선물장 상품으로 비트코인과 알트의 🔴하락에 관여, 강력한 하방 조정장치입니다. 30분마다 구획이 잡히며, 🟢BITI의 최고점 때 매수타점형성되며 15분 딜레이가 있기에 CFD와 도미넌스가 미래, BITI는 15분전 과거로 판단하시면 됩니다.' },
    { symbol: 'FOREXCOM:NSXUSD', title: '🥰 나스닥 기술주 선물100선..."비트의 든든한 백"', desc: '24시간 운영되며, 친블록체인 기업들이 대거 포진되어 있습니다. 🟢상승에 관여, 나스닥과 커플링되는 힘을 만듭니다. 🔴하락이 심화가 되면 비트도 함께 영향을 받습니다. 하방 맞고 저점반등 때 타점형성이 자주 이뤄집니다.' },
    { symbol: 'BTCUSDLONGS', title: '🌋 상방 계약체결한 주문수..."올라가즈아"', desc: '비트파이넥스 선물거래소의 롱미체결 거래건수를 의미합니다. 상승시 실제 차트의 🟢상승 동력원을 제공합니다. 익절 또는 청산되어 하락시 현물흐름이 하방세로 전환되는 분기가 만들어지며 24시간 운영 됩니다.' },
    { symbol: 'BTCUSDSHORTS', title: '🌊 하방 계약체결한 주문수..."내려가야제"', desc: '비트파이넥스 선물거래소의 숏미체결 거래건수를 의미합니다. 🔴상승시 실제 차트의 하방 동력원을 제공합니다. 🟢익절 또는 청산되어 하락시 현물흐름이 상승세로 전환되는 분기가 만들어지며 24시간 운영 됩니다.' },
    { symbol: 'KOSPI', title: '🥷 코스피, 평일 9시 - 오후 15시 30분... "국내 증시 큰손 움직임"', desc: '국내 공휴일이 있는 경우 코인장에 자금이동을 체크해보는 것이 중요하며 연휴가 끝나는날 기준으로 변동성을 꼭 점검하시기 바랍니다.' },
    { symbol: 'FX_IDC:USDKRW', title: '💸 실시간 원-달러 환율..."고환 vs 저환"', desc: '금일 원화와 달러간의 환율을 의미합니다. 고환율일 경우 비트코인의 🛬해외유출 적고 국내 반입이 많은 편이고 저환율일경우 증가합니다. 재정거래의 빈도와 크기는 선물장 또는 현물장에 대한 움직임, 재정계, 채굴, 스테이블코인, 스테이킹, 디파이에 영향을 끼치게 됩니다.' },
    { symbol: '(UPBIT:BTCKRW/(BINANCEUS:BTCUSDT*FX_IDC:USDKRW))*100-100', title: '🚨 그래서 오늘 김프는?..."바이낸스와 업비트 차이"', desc: '바이낸스와 업비트간의 가격차이를 의미 합니다. 가격차이가 심한경우 국내에서는 하락장 방어, 고환율 상태 또는 한국에서만 인기 있는 경우입니다. 높은김프가 발생되면 재정거래자가 증가하여 시세가 불안정 할 수 있습니다.' },
  ]
   
  return (
    <Paper>
      <Option.Group>
        <Option href="#showDetails" onClick={e => [e.stopPropagation(), e.preventDefault(), setOption({ ...options, showDetails: !options.showDetails })]}>
          🥲 코린이를 위한 차트설명 {options.showDetails ? `닫기` : `열기`}
        </Option>
      </Option.Group>
      <Box.Group>
        {markets.map(({ symbol, title, desc }, mIdx) => {
          const encoded = encodeURIComponent(symbol)
          return (
            <Box key={mIdx} className="animate__animated animate__fadeIn" style={{ animationDelay: `${4 + 0.3 * mIdx}s` }}>
              <iframe style={{ position: 'relative', zIndex: '1' }} src={`https://www.tradingview.com/widgetembed/?frameElementId=tradingview_e333a&symbol=${encoded}&interval=15&studies=MACD%40tv-basicstudies%1FBB%40tv-basicstudies%1FMASimple%40tv-basicstudies%1FZigZag%40tv-basicstudies%1FLinearRegression%40tv-basicstudies&theme=dark&style=8&timezone=Asia%2FSeoul&locale=kr&utm_source=coinrbi.com&utm_medium=widget_new&saveimage=0&utm_campaign=chart&utm_term=${encoded}`} width={'100%'} height={`480px`} frameBorder={0} />
              {options.showDetails
                ? (<div>
                    <div style={{ fontSize: '1em', padding: '0.5rem 0' }}>
                      <strong>{title}</strong>
                    </div>
                    <div style={{ fontSize: '0.85em' }}>{desc}</div>
                  </div>)
                : null}
            </Box>
          )
        })}
      </Box.Group>
    </Paper>
  )
}

export default DetailChartsWidget